<template>
    <div class="burn-item"
        :class="{'burn-item-expired': isExpired}"
        @click="clickBurn">
   
        <div class="burn-expired-screen" v-if="isExpired || isUsed"></div>
        <div class="burn-img">
            <img class="img-fluid" :src="burn.fullImageUrl">
        </div>
        <div class="burn-text">
            <div class="date">{{getBurnDate()}}</div>
            <div class="name">{{burn.name}}</div>
            <div class="used-point">ใช้ไป {{pointFormat(burn.pointPerUnit)}} คะแนน</div>
            <div class="message-row"
                v-if="(type == 'burn' && !isShowDelivery && !isSurpriseBox && !isHoroscopeCampaign && !isTypeVerifyCode && !isTypeDonate)">
                <div class="btn-wrapper" :class="{'expired': isExpired}">
                    <div class="btn-txt"
                        v-html="burnMsg">
                    </div>
                </div>
            </div>
            <div class="message-row"
                v-if="(type == 'burn' && !isShowDelivery && !isSurpriseBox && isHoroscopeCampaign && !isTypeDonate)">
                <div class="btn-wrapper">
                    <div class="btn-txt"
                        v-html="lbl.horoscope.burn_btn">
                    </div>
                </div>
            </div>
            <div class="message-row"
                v-if="type == 'draw'">
                <div class="message-txt"
                    v-html="drawMsg"></div>
            </div>
            <!-- <div class="message-row"
                v-if="type == 'interface'">
                <div class="message-txt"
                    v-html="interfaceMsg"></div>
            </div> -->

            <!-- <div class="message-row message-row-icon"
                v-if="isShowDelivery && !isShipped">
                <div class="message-parcelno">
                    <img class="img-fluid" src="../../../assets/icon/ic-package.svg" />
                    <div class="pl-2 pr-3">{{`${burn.parcelNo}`}}</div>
                    <img class="img-fluid" src="../../../assets/icon/ic-copy.svg" />
                </div>
                <div class="message-txt delivery">
                    {{lblPurchase.delivery}}
                </div>
            </div>
            <div class="message-row message-row-icon"
                v-if="isShowDelivery && isShipped">
                <div class="message-parcelno">
                    <img class="img-fluid" src="../../../assets/icon/ic-package.svg" />
                    <div class="pl-2 pr-3">{{`${burn.parcelNo}`}}</div>
                    <img class="img-fluid" src="../../../assets/icon/ic-copy.svg" />
                </div>
                <div class="message-txt shipped">
                    <div>{{`${lblPurchase.shipped}`}}</div>
                </div>
            </div> -->

            <div v-if="isShipped" class="message-row message-row-icon">
                <div class="message-parcelno">
                    <img class="img-fluid" src="../../../assets/icon/ic-package.svg" />
                    <div class="pl-2 pr-3">{{burn.parcelNo}}</div>
                    <div v-clipboard:copy="burn.parcelNo" v-clipboard:success="onSuccess">
                        <div class="icon-copy">
                            <img v-if="isCopySuccess" class="img-fluid" src="../../../assets/icon/ic-copy-active.png" />
                            <img v-else class="img-fluid" src="../../../assets/icon/ic-copy-inactive.png" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isShowDelivery" class="message-row message-row-icon pt-0"> <!-- status -->
                <div class="message-txt" v-html="deliveryMsg"></div>
            </div>

            <div v-if="isShowPrivilegeMsg" class="message-row">
                <div class="message-txt" v-html="privilegeMsg"></div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
//error
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//helper
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';
//service
import BzbsBurnPoint from '@/core/History/service/BzbsBurnPoint.js';

export default {
    name: 'BurnItem',
    mixins: [ErrorApiMixin],
    components: '',
    props: {
        lbl: Object,
        index: Number,
        burn: Object,
        passcode_category: Array,
        controller: Object,
        burnController: Object,
        surpriseCampaignId: Number,
        horoscope_category: String,
    },
    data: function () {
        return {
            lblHistory: this.lbl.history,
            lblPurchase: this.lbl.purchase,
            //item
            type: 'burn', //draw, interface, burn.
            isClickAble: false,
            isExpired: false,
            //purchase
            isShowCode: false,
            burnMsg: null,
            //draw
            isAnnounce: false,
            isWinner: false,
            drawMsg: null,
            //interface
            interfaceMsg: false,
            //delivery
            isShowDelivery: false,
            isShipped: false,
            deliveryMsg: null,
            //privilege message
            isShowPrivilegeMsg: true,
            privilegeMsg: this.burn.privilegeMessage,

            //custom
            isShowpasscode: false,
            isUsed: false,
            isHoroscope: false,
            isCopySuccess: true,
        };
    },
    computed: {
        isSurpriseBox: function() {
            return (this.burn.id == this.surpriseCampaignId);
        },
        isHoroscopeCampaign: function() {
            return (parseInt(this.burn.categoryID) == parseInt(this.horoscope_category));
        },
        isTypeVerifyCode: function() {
            return (this.burn.type == Vue.CampaignType.VerifyCode);
        },
        isTypeDonate: function() {
            return (this.burn.type == Vue.CampaignType.Donate);
        }
    },
    created: function () {
        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        var cateArr = this.passcode_category;
        var cateFiltered = cateArr.filter(val => {
            return (this.burn.categoryID == val)
        });

        this.isShowpasscode = (cateFiltered.length > 0);
        this.initialBurnItem();
    },
    mounted: function () {
        this.burnController.cbReinitialBurnItem.onCallback(this.reinitialBurnItem);
    },
    methods: {
        //event
        clickBurn: function () {
            if (!this.isClickAble) return;
            if (this.isExpired) return;
            if (this.isShowpasscode && this.burn.isUsed == true) return;
            if (this.isUsed) return;
            if (this.isSurpriseBox) return;

            if (this.burn.type === Vue.CampaignType.Interface) {
                var sToken = Account.getTokenShuffle();
                var locale = Locale.getLocaleCode();
                var header = 'false';
                var theme = Vue.bzbsConfig.appname;
                var returnUrl = encodeURIComponent(window.location.href);

                if (this.burn.privilegeMessageFormat == 'link') {
                    var url = this.burn.privilegeMessage;

                    url = url.replace('<campaign_id>', this.burn.CampaignId);
                    url = url.replace('<token>', sToken);
                    url = url.replace('<serial>', this.burn.serial);
                    url = url.replace('<locale>', Locale.getLocaleCode());

                    url += '&return_url=' + returnUrl;

                    window.location.replace(url);
                    return;
                }

                // old default landing interface
                if (this.burn.website
                    && this.burn.website.indexOf('starbucks') > 0) {
                    Account.setCacheCustom('ishistoryfromlanding', { page: 'interface' });
                    window.location.href = this.burn.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + this.burn.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                        '&return_url=' + returnUrl; // ReturnUrl;
                } else if (this.burn.website
                    && this.burn.website.indexOf('linesticker') > 0) {
                    Account.setCacheCustom('ishistoryfromlanding', { page: 'other' });
                    window.location.href = this.burn.website
                        + "&info2=" + this.burn.info2
                        + "&info3=" + this.burn.info3
                        + "&locale=" + locale
                        + "&return_url=" + encodeURIComponent(window.location.href)
                        + "&token=" + sToken
                        + "&is_history=true";
                }
            }

            if(this.isHoroscopeCampaign){
                this.$router.push('/horoscope/'+ this.burn.id);
            }else{
                this.getRedeem(res => {
                    this.initSerial(res);
                });
            }
        },
        //initial
        initialBurnItem: function () {
            // console.log('burn', this.burn);
            if (this.burn.privilegeMessageFormat
                && this.burn.privilegeMessageFormat.toLowerCase() === 'html')
                this.isShowPrivilegeMsg = false;
            switch (this.burn.type) {
                case Vue.CampaignType.Draw:
                    this.initialDraw();
                    break;
                case Vue.CampaignType.Free:
                case Vue.CampaignType.Deal:
                    this.initialBurn();
                    break;
                case Vue.CampaignType.Buy:
                case Vue.CampaignType.Interface:
                    this.initialInterface();
                    break;
            }
            this.initialDelivery();

            this.privilegeMsg = Util.newLineToBr(this.privilegeMsg);
        },
        reinitialBurnItem: function (data) {
            if (this.index != data.index) return;

            this.initialBurnItem();
        },
        //method
        initialDraw: function () {
            this.type = 'draw';
            this.drawMsg = this.lblPurchase.not_draw1 + (this.lblPurchase.not_draw2 ? ' ' + this.lblPurchase.not_draw2 : '');
            if (this.burn.hasWinner) {
                this.isAnnounce = true;
                if (this.burn.isWinner) {
                    this.isWinner = true;
                    this.drawMsg = this.lblPurchase.draw_winner1 + (this.lblPurchase.draw_winner2 ? ' ' + this.lblPurchase.draw_winner2 : '');
                    // if (this.isShowAdsMessage && this.burn.adsMessage)
                    //     this.drawMsg += "<br />" + this.burn.adsMessage;
                } else {
                    this.isWinner = false;
                    this.drawMsg = this.lblPurchase.draw_not_win1 + (this.lblPurchase.draw_not_win2 ? ' ' + this.lblPurchase.draw_not_win2 : '');
                }
            }

            this.isShowPrivilegeMsg = false;
        },
        initialBurn: async function () {
            this.type = 'burn';
            //check horoscope campaign
            if (this.burn.serial == "XXXXXXX") {
                if(this.isHoroscopeCampaign){
                    this.isClickAble = true;
                    this.isExpired = false;
                    this.burnMsg = this.lbl.horoscope.burn_btn;
                }else{
                    this.isClickAble = false;
                    this.isExpired = true;
                    this.burnMsg = this.lblPurchase.code_expired;
                }

            } else {
                this.isClickAble = true;
                this.isExpired = false;
                this.burnMsg = this.lblPurchase.show_code;
            }

            if (this.isShowpasscode && this.burn.isUsed == true) {
                this.isUsed = true;
            }
            this.burnMsg = Util.newLineToBr(this.burnMsg);
        },
        initialInterface: function () {
            this.type = 'interface';
            this.isClickAble = false;
            if (this.burn.expireIn &&
                this.burn.expireIn < 0) {
                this.isExpired = true;
                this.interfaceMsg = this.lblPurchase.code_expired;

                this.isShowPrivilegeMsg = false;
            } else {
                this.interfaceMsg = this.burn.pointType == "get"
                    ? this.lblPurchase.interface_get
                    : this.lblPurchase.interface_use;
            }

            if (this.burn.privilegeMessageFormat == 'link') {
                this.isClickAble = true;
                this.isShowPrivilegeMsg = false;
            }

            this.interfaceMsg = Util.newLineToBr(this.interfaceMsg);
        },
        initialDelivery: function () {

            // this.burn.delivered = true
            // this.burn.isShipped = true
            // this.burn.parcelNo = 'EN64233445TH'

            if (this.burn.delivered == true) {
                this.isClickAble = false;
                this.isShowDelivery = true;
                this.isExpired = false;
                if (this.burn.type == Vue.CampaignType.Draw) {
                    if (!this.burn.hasWinner) {
                        this.isShowDelivery = false;
                    } else if (!this.burn.isWinner) {
                        this.isShowDelivery = false;
                    }
                }

                // if (this.burn.isShipped) {
                //     this.isShipped = true;
                //     this.deliveryMsg = this.lblPurchase.shipped;
                // } else {
                //     this.isShipped = false;
                //     this.deliveryMsg = this.lblPurchase.delivery;
                // }

                //update delivery
                if (this.burn.isShipped && this.burn.parcelNo) {
                    this.isShipped = true;
                    this.deliveryMsg = `<div style="color:#15B097;">${this.lblPurchase.shipped}</div>`;

                } else if (!this.burn.isShipped && this.burn.parcelNo)  {
                    this.isShipped = true;
                    this.deliveryMsg =  `<div style="color:#EDA145;">${this.lblPurchase.delivery}</div>`;
                } else {
                    this.isShipped = false;
                    this.deliveryMsg = `<div>${this.lblPurchase.prepare}</div>`;
                }
            }

            this.deliveryMsg = Util.newLineToBr(this.deliveryMsg);
        },
        initSerial: function (redeemData) {
            this.controller.serialModal
                .setCampaign(redeemData)
                .setPage('detail')
                .setTag('detail')
                .setPasscodeCategory(this.passcode_category)
                .show();

            this.controller.serialModal
                .onClickAction(data => {
                    if (data) {
                        switch(data.action) {
                            case 'expired':
                                this.getRedeem();
                                break;
                        }
                    }
                });

            this.controller.serialModal
                .onClickClose(data => {
                    if (data.tag == 'detail-passcode') {

                        this.isUsed = true;

                        this.controller.confirmModal
                            .clearText()
                            .setTag('redeem-success')
                            .setTitle(this.lbl.serial.redeem_success_headline)
                            .setMsg(this.burn.name)
                            .setBtnCancel(this.lbl.serial.redeem_success_close)
                            .setBtnOk(this.lbl.serial.redeem_success_history)
                            .show();

                    }
                });
        },
        getRedeem: function (callback) {
            var token = Account.getToken();
            BzbsBurnPoint.apiRedeem(token, this.burn.redeemKey)
                .then(res => {
                    this.burnController.updateBurnItem(this.index, res);

                    if (typeof callback == 'function')
                        callback(res);
                }).catch(err => {
                    this.errorResponse(err, this.errorHandler);
                })
        },
        //util
        getBurnDate: function () {
            var redeemDate = this.burn.redeemDate;
            var message = this.lbl.detail.news_time;

            var result = Moment.unix(redeemDate).utc();
            var year = Moment.unix(redeemDate).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');

            var date = `${day}/${month}/${year}`;
            var time = result.format('HH:mm');
            //var monthString = this.lblDate.month_short[result.format('M') - 1];

            return Util.stringFormat(message, date, time);
        },
        pointFormat: function (point) {
            return Util.formatNum(point);
        },
        onSuccess: function (e) {
            this.isCopySuccess = false
            setTimeout(() => {
                this.isCopySuccess = true
            }, 500);
            console.log("You just copied: " + e.text);
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.burn-item{
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 1px solid $a-gray-C4C4C4;
    position: relative;
    
    &:first-child {
        padding-top: 0;
    }

    .burn-expired-screen {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 1px;
        background: rgba(#ffffff, 0.5);
        background-position: center center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        z-index: 100;
    }

    .burn-img {
        @include baseCampaignImg(66.67%);
        width: 100px;
        height: auto;
        border-radius: 10px;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
    }
    .burn-text {
        width: calc(100% - 100px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;

        .date {
            color: $a-gray-A0A0A0;
            font-family: $regular;
            font-size: 1.25rem;
            line-height: normal;
        }

        .name {
            @extend %ellipsis-2;
            color: $a-gray-333333;
            font-family: $regular;
            font-size: 1.5rem;
            line-height: normal;
        }

        .used-point {
            color: $orange;
            font-family: $regular;
            font-size: 1.5rem;
            line-height: normal;
            // margin-bottom: 10px;
        }

        .message-row {

            .message-txt {
                width: 100%;

                &.delivery {
                    color: $a-yellow-EDA145;
                }

                &.shipped {
                    color: $green-15B097;
                }
            }

            .btn-wrapper{
                max-width: fit-content;
                background-color: #ffffff;
                border: 1px solid $green-00987F;
                min-height: 30px;
                margin-top: 10px;
                box-shadow: none;

                .btn-txt{
                    color: $green-00987F;
                    font-family: $semi_bold;
                    font-size: 1.5rem;
                }

                &.expired{
                    border: 1px solid $a-gray-E8E8E8;
                    background-color: $a-gray-E8E8E8;
                    color: $a-gray-A0A0A0;

                    .btn-txt{
                        font-family: $regular;
                        color: $a-gray-A0A0A0;
                    }
                }
            }

            &.message-row-icon {
                width: 100%;
                padding-top: 5px;

                .message-icon {
                    display: flex;
                }

                .message-parcelno {
                    display: flex;
                    align-items: center;
                    font-size: 1.5rem;
                    font-family: $semi_bold;
                    color: $a-gray-575757;
                    line-height: normal;
                    margin-bottom: 8px;

                    .icon-copy {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 22px;
                        height: 22px;
                    }

                }
                .message-txt {
                    font-size: 1.5rem;
                    font-family: $regular;
                    line-height: normal;
                }
            }
        }
    }

    // &.burn-item-expired {
    //     .burn-text {
    //         .used-point {
    //             color: #cecece;
    //         }
    //     }
    // }
}

</style>
